import { useFormValidation } from "@repo/lib/hooks/common";
import { validation } from "@repo/lib/utils";
import { newsletterSubscribe } from "@repo/server-actions/account";
import { useTranslations } from "next-intl";
import { useTransition } from "react";

const formFields = { email: "" };

const useNewsletterSubscribe = () => {
  const [isPending, startTransition] = useTransition();
  const { formValues, formErrors, setFormErrors, handleValidation } =
    useFormValidation(formFields);
  const t = useTranslations("Common");
  const sumbitForm = async () => {
    startTransition(async () => {
      await newsletterSubscribe(formValues);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validation(formValues, t);
    if (Object.keys(errors).length === 0) {
      sumbitForm();
    } else {
      setFormErrors(errors);
      console.log("Failed to submit the form, please check the form fields");
    }
  };

  return { handleSubmit, handleValidation, formValues, isPending, formErrors };
};

export default useNewsletterSubscribe;
